module.exports = [
	{
		id: 'pricenegotiation',
		title: "Price Negotiation",
		description: "Client (often procurement or economic buyer) challenges the price, asking for a lower rate or referencing competitors’ pricing. This is a common, evergreen negotiation scenario across service lines."
	},
	{
		id: 'costjustification',
		title: "Change Orders and Scope Management",
		admin_title: "Change Orders/Scope Management - Tax",
		description: "Scenario involves negotiating change orders or additional billing for extra work performed, highlighting the need to address scope changes and payment for additional services, relevant for both junior and senior staff."
	},
	{
		id: 'changeorder',
		title: "Change Orders and Scope Management",
		admin_title: "Change Orders/Scope Management - Audit",
		description: "Scenario involves negotiating change orders or additional billing for extra work performed, highlighting the need to address scope changes and payment for additional services, relevant for both junior and senior staff."
	}
];
